import batchInitializePolicy from "./queries/batchInitializePolicy.js"
import processPaymentAndIssue from "./queries/processPaymentAndIssue.js"
import batchCreateAllEntities from "./queries/batchCreateAllEntities.js"
import batchAddLinks from "./queries/batchAddLinks.js"
import addOffer from "./queries/addOffer.js"

/* 
  - We have a SDK for checkout calls
  - We will have only one schema that UIConfig can eventually produce for our SDK
  - The checkout SDK will understand that schema and will do calls based on it
  - Super simple for setting up checkout UI - we have only one possible data schema so we can utomate where paticular fields will bind to API probably? 
  except some weird facts that have some modifiers on it, that will have to be set manually somewhere still
*/

// TODO:
// - What about addresses, contacts, identities?
// - Figure out companies as insured or policyHolder
// - token and locale could be passed when creating SDK instance instead of passing it into all functions, will be cleaner

const createPolicy = async ({ payload, token, locale }) => {
	// ------------------------------------------------------------
	// 1 Create all entities
	// ------------------------------------------------------------
	const createdEntities = await batchCreateAllEntities({
		payload,
		token,
		locale
	})
	if (createdEntities.errors)
		return Promise.resolve({ errors: createdEntities.errors })

	// ------------------------------------------------------------
	// 2 Initialize policy
	// ------------------------------------------------------------
	const policyId = await batchInitializePolicy({
		payload,
		createdEntities,
		token,
		locale
	})
	if (policyId.errors) return Promise.resolve({ errors: policyId.errors })

	// ------------------------------------------------------------
	// 3 Create facts and links
	// ------------------------------------------------------------
	const createdLinks = await batchAddLinks({
		payload,
		policyId,
		createdEntities,
		token,
		locale
	})
	if (createdLinks.errors)
		return Promise.resolve({ errors: createdLinks.errors })

	// If all good, return policyId
	return Promise.resolve({ policyId })
}

const createQuote = async ({ payload, token, locale, tenantId }) => {
	// Create quote is actually create policy without pricing and product
	// And adding offer to that policy where we put product and pricing

	// ------------------------------------------------------------
	// 1 Create policy
	// ------------------------------------------------------------
	// Remove pricing and product from original payload if they are there
	const payloadForQuote = JSON.parse(JSON.stringify(payload))
	if (
		payloadForQuote.policyParticulars.pricing !== undefined &&
		payloadForQuote.policyParticulars.productId !== undefined
	) {
		delete payloadForQuote.policyParticulars.pricing
		delete payloadForQuote.policyParticulars.productId
	}

	const policyId = await createPolicy({
		payload: payloadForQuote,
		token,
		locale
	})
	if (policyId.errors) return Promise.resolve({ errors: policyId.errors })

	// ------------------------------------------------------------
	// 2 Add offer to that policy
	// ------------------------------------------------------------
	const { productId, pricing } = payload.policyParticulars
	const offerInput = { productId, premium: pricing }
	const createdOffer = await addOffer({
		policyId: policyId.policyId,
		offerInput,
		token,
		locale
	})
	if (createdOffer.errors)
		return Promise.resolve({ errors: createdOffer.errors })

	// If all good, return policyId
	return Promise.resolve({ policyId: policyId.policyId })
}

const payAndIssuePolicy = async ({
	payload,
	paymentToken,
	policyId,
	token,
	locale
}) => {
	// ------------------------------------------------------------
	// 1 Process payment and issue
	// ------------------------------------------------------------
	const issuedPolicy = await processPaymentAndIssue({
		paymentInput: {
			policyId,
			amount: payload.policyParticulars.pricing.amount,
			currencyCode: payload.policyParticulars.pricing.currencyCode,
			userToken: paymentToken
		},
		token,
		locale
	})
	if (issuedPolicy.errors)
		return Promise.resolve({ errors: issuedPolicy.errors })

	// If all good, return policyStatus object
	return Promise.resolve(true)
}

export default {
	createPolicy,
	createQuote,
	payAndIssuePolicy
}
